module.exports = __webpack_public_path__ + "static/media/0179_Medium.18fad2b7.jpg";